module.exports = __webpack_public_path__ + "assets/static/png/icons_arrow.f419745a6e6b3cd54a4b818bfefeebf8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/icons_arrow.png
 ** module id = 22
 ** module chunks = 1
 **/